import axios from 'axios';
import { IGamificationApiCall, IRestApiService, TokenResponse, UserInventory } from '../types';
import { IUserQuestDTO } from '../feature-client-cabinet/lib/client-cabinet/store/types/IUserQuest.dto';

class GamificationApiCall implements IGamificationApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getUserToken(): Promise<TokenResponse> {
    return this.restApiService.get('gamification/user/token');
  }

  trackUserEvent(eventName: string, data: any): Promise<void> {
    return this.restApiService.post(
      `gamification/track-event/${eventName}`,
      data
    );
  }

  getUserInventory(token: string): Promise<UserInventory> {
    const options = {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    return axios
      .get(
        'https://gelios.apps.scrimmage.co/p2e/players/@me/resources',
        options
      )
      .then(function (response) {
        return response.data;
      });
  }

  getQuests(token: string): Promise<IUserQuestDTO[]> {
    const options = {
      method: 'GET',
      url: 'https://gelios.apps.scrimmage.co/p2e/players/@me/assignments',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    return axios.request(options).then(function (response) {
      return response.data;
    });
  }

  acceptQuest(token: string, questId: string): Promise<any> {
    const options = {
      method: 'POST',
      url: `https://gelios.apps.scrimmage.co/p2e/players/@me/assignments/${questId}/accept`,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    return axios.request(options).then(function (response) {
      return response.data;
    });
  }

  claimQuestReward(token: string, questId: string): Promise<any> {
    const options = {
      method: 'POST',
      url: `https://gelios.apps.scrimmage.co/p2e/players/@me/assignments/${questId}/claim`,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    return axios.request(options).then(function (response) {
      return response.data;
    });
  }

  cancelQuest(token: string, questId: string): Promise<any> {
    const options = {
      method: 'POST',
      url: `https://gelios.apps.scrimmage.co/p2e/players/@me/assignments/${questId}/cancel`,
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };

    return axios.request(options).then(function (response) {
      return response.data;
    });
  }
}

export default GamificationApiCall;